"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var methods_1 = require("./dom/methods");
var cookies_1 = require("../utils/cookies");
var requests_1 = require("./requests");
var auth_1 = require("../auth");
var methods = {
  openModal: methods_1.openModal,
  hideModal: methods_1.hideModal,
  _hideLoader: methods_1.hideLoader,
  _showLoader: methods_1.showLoader,
  _showMessage: methods_1.showMessage,
  getMemberCookie: cookies_1.getMemberCookie,
  onAuthChange: auth_1.onAuthChange
};
function _init(props) {
  var requests = requests_1.initRequest({
    publicKey: props.publicKey,
    appId: props.appId,
    sessionDurationDays: props.sessionDurationDays,
    token: cookies_1.getMemberCookie()
  });
  var allMethods = Object.assign(methods, requests);
  if (typeof window !== "undefined") {
    //@ts-ignore
    window.$memberstackDom = allMethods;
  }
  return allMethods;
}
exports.default = {
  init: function init(props) {
    return _init(props);
  }
};